import React from 'react';
import { useLocation } from 'react-router-dom';
import StylingMockNav from './StylingMockNav';
import './StylingMock.css';

/**
 * Shared Layout Component for Styling Mock Pages
 * Provides consistent layout and navigation. Theme from config (no dark mode toggle).
 */
const StylingMockLayout = ({ children }) => {
  const location = useLocation();

  return (
    <div className="styling-mock-page">
      <div className="styling-mock-container">
        {/* Header */}
        <header className="styling-mock-header">
          <div className="styling-mock-header-content">
            <div className="styling-mock-title-section">
              <h1 className="styling-mock-title">Press Kit</h1>
              <p className="styling-mock-subtitle">Component Showcase & Style Guide</p>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <div className="styling-mock-main">
          {/* Side Navigation */}
          <aside className="styling-mock-sidebar">
            <StylingMockNav currentPath={location.pathname} />
          </aside>

          {/* Content Area */}
          <main className="styling-mock-content">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default StylingMockLayout;

